// extracted by mini-css-extract-plugin
export default {"clearMenuItem":"ResourceTypeFilter_clearMenuItem__APARD"};